import { FC } from 'react';
import { SignatureInput as SignatureInputC } from '../../../components/SignatureInput';
import {
  addQuestionFiles,
  removeQuestionFiles,
  useCurrentAnswer,
  useCurrentQuestion,
} from '../../../services/inspection';
import { AnswerState, Question } from '../types';

export const SignatureInput: FC = () => {
  const { id } = useCurrentQuestion() as Question;
  const { files } = useCurrentAnswer() as AnswerState;

  return (
    <SignatureInputC
      value={files?.[0]?.src}
      onChange={(file) => addQuestionFiles(id, [file])}
      onClear={() => removeQuestionFiles(id, 0)}
    />
  );
};
